import {
  Window,
  FunctionHandler,
  FunctionCallback,
  JsonData,
} from './shared/akatypes';

declare const window: Window;

const jQuery = window.jQuery;

export function GenerateMyCourses(courses: Array<any>) {
  let ret = '';
  courses.forEach((data) => {
    if (data.isfuture) {
      ret +=
        '<p>' +
        formatDate(data.time) +
        ' ' +
        '<a href="' +
        window.cnfg_http_aka_php_base +
        'kurz.php?id=' +
        data.courseid +
        '">' +
        data.coursename +
        '</a></p>';
    }
  });
  return ret;
}

function stavPlatby(datastate: string) {
  if (datastate === 'payorder') return 'nezaplaceno: ';
  if (
    datastate === 'paid' ||
    datastate === 'processing' ||
    datastate === 'processed'
  )
    return 'zaplaceno: ';

  return 'stav platby-' + datastate; // toto by nemelo nastat
}

export function GenerateMyOrders(orders: Array<any>) {
  let ret = '';

  orders.forEach((data) => {
    let coursenames = '';
    if (data.coursenames) {
      coursenames = '' + data.coursenames + '';
    }
    ret +=
      '<p>' +
      '<a href="' +
      window.cnfg_http_aka_php_base +
      'objednavka.php?id=' +
      data.orderid +
      '">Objednávka z ' +
      // formatDate(data.time) +
      data.time +
      '</a> ' +
      stavPlatby(data.state) +
      coursenames +
      '</p>';
  });
  return ret;
}
function ifNotEmpty(data: string, showText: string) {
  return data === null || data === '' || data === undefined ? '' : showText;
}

export function GenerateCourseDetailTile(data: any) {
  /*
  let typ;
  if (data.type == '1') {
    typ = 'Online kurz';
  } else {
    typ = 'Prezenční kurz';
  }
  */
  let date = '';
  if (data.date == '') {
    date = 'Termín bude upřesněn';
  } else {
    date = formatDate(data.date);
    console.log('formatuju datum:', data.date, date);
  }
  const html =
    '' +
    '<div>' +
    '<div class="h1 u-mb-sm"><span class="icon-svg icon-svg--bracket  u-color-lightgreen"><svg class="icon-svg__svg" xmlns:xlink="https://www.w3.org/1999/xlink"><use xlink:href="css/icon-bracket.svg#icon-bracket" x="0" y="0" width="100%" height="100%"></use></svg></span><span class="title--bracket">' +
    data.title +
    '</span></div>' +
    '<div class="row-main">' +
    '<div class="grid u-mb-md">' +
    '<div class="grid__cell size--12-12 size--8-12@md u-mb-md">' +
    /*'<div>' +
    typ +
    '</div>' +
    */
    ifNotEmpty(
      data.programtext,
      '<h2>Program</h2><p>' + data.programtext + '</p>',
    ) +
    //    ifNotEmpty(
    //      data.infotomail,
    // '<h2>Multimédia</h2>' + data.multimedialinks,
    //      '<p>' + data.infotomail + '</p>',
    //    ) +
    ifNotEmpty(
      data.multimedialinks,
      // '<h2>Multimédia</h2>' + data.multimedialinks,
      '<p>' + data.multimedialinks + '</p>',
    ) +
    ifNotEmpty(
      data.whomtext,
      '<h2>Pro koho</h2>' +
      data.whomtext +
      ifNotEmpty(
        data.stornotext,
        '<h2>Storno podmínky</h2><p>' + data.stornotext + '</p>',
      ) +
      ifNotEmpty(
        data.writtenabout,
        '<h2>Napsali o nás</h2><p>' + data.writtenabout,
      ) +
      '</p>',
    ) +
    '</div>' +
    '<div class="grid__cell size--12-12 size--4-12@md">' +
    '<div class="course-detail--rightcol">' +
    '<div id="occupancy1_' +
    data.id +
    '" class="course-detail--occupancy"></div>' +
    '<div id="interestdiv"></div>' +
    '<div id="addtocart_' +
    data.id +
    '" class="b-addtocart btn addtocarthidden"><a href="cart.php?addid=' +
    data.id +
    '" onclick="addcart(' +
    data.id +
    ", '" +
    data.title +
    '\');return false;" class="btn__text btn__text--small"><span class="icon-svg icon-svg--cart ">' +
    '<svg class="icon-svg__svg" xmlns:xlink="https://www.w3.org/1999/xlink">' +
    '<use xlink:href="https://akademie.ctk.cz/css/icon-kosik.svg#icon-cart" x="0" y="0" width="100%" height="100%"></use></svg></span><span>Objednat</span></a></div>' +
    /*'<div id="addtocart2_' +
    data.id +
    '">+
     <a href="cart.php?addid=' +
    data.id +
    '" onclick="addcart(' +
    data.id +
    ", '" +
    data.title +
    '\');return false;" class="u-color-lightgreen u-text-md">.</a>'+
    '</div>' */
    '<div><h2>Cena</h2><div class="b-course__price">' +
    data.price +
    '&nbsp;Kč</div>' +
    '<div class="b-course__no-tax">' +
    data.pricedph +
    '</div></div>' +
    '<div><h2>Termín</h2><p>' +
    date +
    '</p></div>' +
    '<div id="instancediv"></div>' +
    ifNotEmpty(
      data.whentext,
      '<div><h2>Kdy</h2><p>' + data.whentext + '</p></div>',
    ) +
    ifNotEmpty(
      data.placetext,
      '<div><h2>Kde</h2><p>' + data.placetext + '</p></div>',
    ) +
    ifNotEmpty(
      data.lecturernames,
      '<div><h2>Lektor</h2><p><a href="lektori.php">' +
      data.lecturernames +
      '</a></p></div>',
    ) +
    '</div></div></div></div>';
  return html;
}

function removeLeadingZero(str: string) {
  return str.substring(0, 1) === '0' ? str.substring(1) : str;
}

function formatDate(date: string) {
  const y = date.substring(0, 4);
  const m = removeLeadingZero(date.substring(5, 7));
  const d = removeLeadingZero(date.substring(8, 10));
  return `${d}. ${m}. ${y}`;
}

export function GenerateCourseInstancesTile(dataArray: Array<any>) {
  const html = dataArray
    .filter((it) => it.date !== '')
    .map(
      (it) =>
        '' +
        '<a href="kurz.php?id=' +
        it.id +
        '" />' +
        formatDate(it.date) +
        '</a>',
    )
    .join('<br />');
  return dataArray.length > 1 ? '<h2>Všechny termíny</h2>' + html : '';
}

export function GenerateInterestDialog(id: string) {
  let emailfromloginhead = 'aaa';
  // if (jQuery('#user-menu-link').length > 0) {
  emailfromloginhead = jQuery('#user-menu-link').text();
  //}
  const html =
    '<div class="b-interest"><h2 id="saveinterestheader">Hlídat dostupnost</h2><div id="saveinterestblock" class="b-interest__inner u-mb-sm u-hide"><p>E-mail:</p><p><input class="inp-text" type="text" id="interestemailid" value= "' +
    emailfromloginhead +
    '" /></p><p class="u-text-right"><span class="btn"><button class="btn__text btn__text--small" onclick="saveinterest(' +
    id +
    ');return false;"">Uložit</button></span></p><p class="u-text-smaller">*Stisknutím tlačítka uložit souhlasíte s <a href="' +
    window.cnfg_http_aka_tomojectk_base +
    'obchodni-podminky.php">Podmínkami pro uchovávání osobních údajů</a>.</p></div><p>Zadejte e-mail pro informace o novém kurzu.</p></div>';
  return html;
}

function GenerateCourseTile(data: any) {
  /*
  let typ;
  if (data.type == '1') {
    typ = 'Online kurz';
  } else {
    typ = 'Prezenční kurz';
  }
  */
  let date = '';
  if (data.templatecourse || data.date == '') {
    date = 'Plánujeme';
  } else {
    date = formatDate(data.date);
    console.log('formatuju datum:', data.date, date);
  }
  const html =
    '' +
    '<div class="coursetile c-courses__item grid__cell grid__cell--eq size--12-12 size--6-12@md size--4-12@lg size--6-12--print"><div class="b-course">' +
    '<div class="b-course__type u-pull-right">' +
    '<div id="occupancy1_' +
    data.id +
    '" class="b-course__occupancy"></div>' +
    '</div>' +
    '<div class="b-course__date">' +
    date +
    '</div>' +
    '<div class="h3 b-course__title"><a href="kurz.php?id=' +
    data.id +
    '">' +
    data.title +
    '</a></div>' +
    '<p>' +
    data.text +
    '</p>' +
    '<div class="grid">' +
    '<div class="grid__cell grid__cell--eq size--7-12 size--6-12--print">' +
    '<div><div class="b-course__price">' +
    data.price +
    '&nbsp;Kč</div>' +
    '<div class="b-course__no-tax">' +
    data.pricedph +
    '</div></div></div>' +
    '<div class="b-course__details grid__cell grid__cell--eq grid__cell--bottom size--5-12 size--6-12--print u-text-right"><a href="kurz.php?id=' +
    data.id +
    '">Podrobnosti</a></div></div>' +
    '</div></div>';

  return html;
}

export function GenerateCourseTiles(courses: Array<any>) {
  const filteredDataArray: Array<string> = []; // pole id kurzu, ktere pak zobrazim
  const usedCourses: Array<string> = []; // idcka generickych kurzu, jejichz instance uz zobrazuji ve filtered poli
  courses
    .filter((data) => !(data.id == 153 || data.id == 152))
    .forEach((data) => {
      const currentid = data.id;
      if (data.templatecourse === true && !usedCourses.includes(currentid)) {
        // zobraz genericky kurz, pouze pokud jeste nezobrazil svou instanci
        filteredDataArray.push(data);
        usedCourses.push(currentid);
      }
      if (data.templatecourse === false) {
        // zobraz kazdou instanci - klidne i kdyz je potomkem generickeho kurzu, ktery uz zobrazuje jinou svou instanci (na tom jsem se dohodli 12.1.2023)
        filteredDataArray.push(data);
        usedCourses.push(data.templateid);
      }

      /* else if (
      data.templatecourse === false &&
      !usedCourses.includes(data.templateid)
    ) {
      // nezobrazuj instanci kurzu, ktery uz zobrazil predchozi instanci
      filteredDataArray.push(data);
      if (data.templateid) {
        usedCourses.push(data.templateid);
      }
    }
    */
    });

  return filteredDataArray
    .map((it: any) => '' + GenerateCourseTile(it) + '')
    .join('\n');
}

export function GenerateFewCourseTiles(courses: Array<any>) {
  const filteredDataArray: Array<string> = []; // pole id kurzu, ktere pak zobrazim
  const usedCourses: Array<string> = []; // idcka generickych kurzu, jejichz instance uz zobrazuji ve filtered poli
  courses
    .filter((data) => !(data.id == 153 || data.id == 152))
    .forEach((data) => {
      const currentid = data.id;
      if (
        false &&
        data.templatecourse === true &&
        !usedCourses.includes(currentid)
      ) {
        // zobraz genericky kurz, pouze pokud jeste nezobrazil svou instanci
        filteredDataArray.push(data);
        usedCourses.push(currentid);
      }
      if (data.templatecourse === false) {
        // zobraz kazdou instanci - klidne i kdyz je potomkem generickeho kurzu, ktery uz zobrazuje jinou svou instanci (na tom jsem se dohodli 12.1.2023)
        filteredDataArray.push(data);
        usedCourses.push(data.templateid);
      }

      /* else if (
      data.templatecourse === false &&
      !usedCourses.includes(data.templateid)
    ) {
      // nezobrazuj instanci kurzu, ktery uz zobrazil predchozi instanci
      filteredDataArray.push(data);
      if (data.templateid) {
        usedCourses.push(data.templateid);
      }
    }
    */
    });

  return filteredDataArray
    .map((it: any) => '' + GenerateCourseTile(it) + '')
    .join('\n');
}

export function GenerateLecturerTile(data: any) {
  let typ;

  const html =
    '' +
    '<div class="lecturertile grid__cell size--12-12 size--6-12@lg size--6-12--print u-mb-lg">' +
    '<div class="grid">' +
    '<div class="grid__cell size--12-12 size--5-12@sm u-text-center u-mb-xsm">' +
    '<img class="b-testemonial__media" src="' +
    data.photourl +
    '" />' +
    '</div>' +
    '<div class="grid__cell size--12-12 size--7-12@sm"><h2>' +
    data.name +
    '</h2>' +
    '<p>' +
    data.description +
    '</p>' +
    '<div id="lecturercourses_' +
    data.id +
    '"></div></div></div>' +
    '</div>';

  return html;
}

export function GenerateLecturerCoursesTiles(dataArray: Array<any>) {
  const filtereDataArray: Array<string> = [];
  const usedNames: Array<string> = [];
  dataArray.forEach((id) => {
    if (!usedNames.includes(window.courseNames[id])) {
      filtereDataArray.push(id);
      usedNames.push(window.courseNames[id]);
    }
  });
  return filtereDataArray
    .map(
      (id) =>
        '' +
        '<a href="kurz.php?id=' +
        id +
        '" />' +
        window.courseNames[id] +
        '</a>',
    )
    .join(', ');
}
